export default __webpack_public_path__ + "static/media/eb-wht-4.5577c823.png";